import $ from 'jquery';
import Masonry from 'masonry-layout';

import ModalContent from '../components/ModalContent';
import FacetedFiltering from '../components/FacetedFiltering';
import ModalView from '../components/ModalView';

export default class TemplateCollection {
  constructor({ el }) {
    this.el = el;
    this.$el = $(el);
    this.filtersEnabled = this.el.querySelector('[data-faceted-filter]');
    this._bindEvents();
    this.validate();

    if (this.filtersEnabled) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }
  }

  _bindEvents() {
    this.events = [
      $('.collection-sorting select', this.$el).on('change.collection', event => this.sortProducts(event)),
      $('.collection-description-more', this.$el).on('click.collection', event => this.createModal(event)),
      $('.collection-sharing-toggle', this.$el).on('click.collection', event => this.toggleSharing(event)),
      $('.share-buttons', this.$el).on('mouseout.collection', event => this.toggleSharing(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.collection'));
  }

  validate() {
    this.section = window.sectionJSON;

    if ($('html').hasClass('lt-ie9') && $('.collection-header', this.$el).length) {
      this.verticallyAlignHeaderText();
    }

    if ($('.collection-products', this.$el).data('layout') === 'masonry') {
      this.masonryLayout();
    }
  }

  verticallyAlignHeaderText() {
    const headerHeight = $('.collection-details', this.$el).height();
    $('.collection-details', this.$el).css({ marginTop: -(headerHeight / 2) });
  }

  toggleSharing(e) {
    if (e.type === 'mouseout') {
      if ($(e.relatedTarget).closest('.share-buttons').length) { return; }
    }

    $('.collection-sharing', this.$el).toggleClass('active');
  }

  sortProducts(e) {
    const search = [];
    const currentSearch = window.location.search.replace('?', '');
    const sortBy = e.currentTarget.value;
    let newSearch;

    if (currentSearch.includes('sort_by')) {
      const searchParts = currentSearch.split('&');

      searchParts.forEach(part => {
        const searchFields = part.split('=');
        if (searchFields[0] === 'sort_by') {
          searchFields[1] = sortBy;
        }

        search.push(searchFields.join('='));
      });

      newSearch = `?${search.join('&')}`;
    } else {
      newSearch = `?${currentSearch}&sort_by=${sortBy}`;
    }

    window.location.search = newSearch;
  }

  masonryLayout() {
    const $products = $('.collection-products', this.$el);

    if ($('.product-list-item', this.$el).length) {
      this.events.push($products.on('rimg:load.collection', () => {
        this.events.push($products.one('layoutComplete', () => $products.addClass('processed')));
        this.masonry = new Masonry($products[0], { transitionDuration: 0 });
      }));
    } else {
      $products.addClass('processed empty-collection');
    }
  }

  createModal() {
    const collectionJSON = JSON.parse($('[data-collection-json]', this.$el).text());
    const modalContent = new ModalContent({
      title: collectionJSON.title,
      message: collectionJSON.body_html,
    });

    this.modalView = new ModalView({
      model: modalContent,
      el: $('.modal-wrapper'),
    });
  }

  onSectionUnload() {
    if (this.facetedFilters) {
      this.facetedFilters.unload();
    }

    this._unbindEvents();
  }
}
